import React, { useEffect, useState } from "react";
import Section from "components/Section";
import ApartmentListings from "components/Apartment/ApartmentListings";
import Selectpicker from "components/Input/Selectpicker";
import TextInput from "components/Input/TextInput";
import Button from "components/Button";
import FeedbackModal from "components/FeedbackModal";

import auth from "functions/auth";

import 'assets/css/Dashboard.min.css';
import clg from "functions/log";
import {reqAuth} from "functions/req";
import modifyState from "functions/modifyState";
import settings from "configs/settings";
import { render } from "@testing-library/react";

const Dashboard = () => {

    const [globalChange, setGlobalChange] = useState({
        "type" : "DEC", //INC
        "percent" : 5,
    });

    const [renderCount,setRenderCount] = useState(0);

    const [globalSubmitBtnLoaderState, setGlobalSubmitBtnLoaderState] = useState(0);

    const [feedback, setFeedback] = useState({
        open : false,
        success : false,
        title : null,
        text : null,
    });

    const submitGlobalChange = () => {
        setGlobalSubmitBtnLoaderState(1);

        clg("DATA TO SEND: ", globalChange);

        if( auth.isAuthenticated() ) {
            reqAuth( settings.req.globalEdit, globalChange ).then(function(res){
                clg("GLOBAL EDIT RES: ", res)
                if( res && res.success ) {
                    modifyState( feedback, setFeedback, {"open" : true, "success" : true, } );
                    setRenderCount(renderCount+1);
                } else {
                    modifyState( feedback, setFeedback, {"open" : true, "success" : false,} );
                }
                setGlobalSubmitBtnLoaderState(0);
            }).catch(function(err){
                modifyState( feedback, setFeedback, {"open" : true, "success" : false, } );
                setGlobalSubmitBtnLoaderState(0);
                clg("GLOBAL EDIT ERROR: ", err);
            })
        }
    }

    return(
        <>

        <FeedbackModal open={feedback.open} success={feedback.success} title={feedback.title} text={feedback.text} defaultState={ feedback } setDefaultState={ setFeedback }/>  

        <Section title="Globális beállítások" description=" " additionalClasses="global-settings-section pb-0 mt-5">
            <div className="row align-items-center ">
                <div className="price-inc-dec-container">
                    <Selectpicker
                        defaultValue={{ value: "DEC", label: "Lakások árainak csökkentése" }}
                        name="status"
                        options={[
                            { value: "DEC", label: "Lakások árainak csökkentése" },
                            { value: "INC", label: "Lakások árainak növelése" },
                        ]}
                        placeholder="Lakások árainak változtatása"
                        className="select-global-price"
                        classNamePrefix="select"
                        onChange={ (selected) => {
                            setGlobalChange({
                                ...globalChange,
                                "type" : selected.value
                            })
                        } }
                    />
                </div>

                <div className="price-percent-container">
                    <TextInput
                        type="number"
                        defaultValue={5}
                        onBlur={ (e) => setGlobalChange({
                            ...globalChange,
                            "percent" : Number(e.target.value)
                        }) }
                    />
                </div>
                <div className="price-percent-postfix-container">százalékkal</div>
            </div>

            <div className="row">
                <div className="col-12 d-flex justify-content-center mt-5">
                    <Button className="btn-secondary" text="Módosítás" loader={globalSubmitBtnLoaderState}  onClick={ () => submitGlobalChange() }></Button>
                </div>
            </div>
            
        </Section>

        <Section title="Lakásokhoz tartozó beállítások" description={renderCount}>
            <ApartmentListings viewType="row" enableViewSelect={false} isAuthenticated={ auth.isAuthenticated() } key={`admin-apartment-listings-${renderCount}`}/>
        </Section>
        </>
    )
}

export default Dashboard;